import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import React from 'react';

import Balance from './dependencies/Balance/Balance';
import useRechargeBalance from './useRechargeBalance';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`${index}`} {...other}>
      {value === index && <Box sx={{ p: '1.5rem 0' }}>{children}</Box>}
    </div>
  );
}

const RechargeBalance = () => {
  const hook = useRechargeBalance();
  const theme = useTheme();

  return (
    <Box sx={{ paddingTop: '1rem', width: '100%' }}>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
        }}
      >
        <Tabs
          value={hook.value}
          onChange={hook.handleChange}
          indicatorColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          sx={{ width: '35vw', [theme.breakpoints.down('lg')]: { width: '80vw' } }}
        >
          {[
            { label: 'Recargar saldo', id: '0' },
            // { label: 'Últimas transacciones', id: '1' },
          ].map((tab) => (
            <Tab label={tab.label} id={tab.id} />
          ))}
        </Tabs>
      </Box>
      <CustomTabPanel value={hook.value} index={0}>
        <Balance />
      </CustomTabPanel>

      {/* <CustomTabPanel value={hook.value} index={1}>
        <LatestTransactions />
      </CustomTabPanel> */}
    </Box>
  );
};

export default RechargeBalance;
